<script setup lang="ts">
/**
 * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [AddToCart]
 * Модальное окно / экран "Ура! Все готово! Добавить в корзину"
 */

// Store
import { ref } from "vue";

// Components
import Modal from "@/components/modal/modal.vue";
import StepsButtons from "@/components/StepsButtons/StepsButtons.vue";
// import Checkbox from "@/ui/checkbox/checkbox.vue";
import { BugTrackerSection, useBugTracker } from "@/helpers/bugTracker";
import { setDeviceStatus } from "@/helpers/singingType";
import it4CheckContractSign from "@/hooks/requests/it4CheckContractSign/it4CheckContractSign";
import it4SendContractToSign from "@/hooks/requests/it4SendContractToSign/it4SendContractToSign";
// Hooks
import useTranslate from "@/hooks/useTranslate/useTranslate";
import { useHowYouRateDeviceStore } from "@/stores/howYouRateDevice/howYouRateDevice";
import { useSuccessfulEvaluationStore } from "@/stores/successfulEvaluation/successfulEvaluation";
import { useTIWStore } from "@/stores/tiw/tiw";
import Button from "@/ui/button/button.vue";
// Icons
import AwardIcon from "@/ui/icons/award.vue";

const TIWStore = useTIWStore();
const HowYouRateDeviceStore = useHowYouRateDeviceStore();
const SuccessfulEvaluationStore = useSuccessfulEvaluationStore();

const isSigned = ref<boolean>(true);
const loadingToNext = ref<boolean>(false);

function cutCertificateNumber(value: string) {
    if (value.length > 20) {
        return value.slice(0, 20);
    }

    return value;
}

async function onNext() {
    const ContractSignInfo = await it4CheckContractSign({
        token: TIWStore.WIDGET_DATA.token,
        deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId,
    });
    if (ContractSignInfo.signed) {
        if (TIWStore.IS_DISCOUNT_LATER) {
            TIWStore.switchStep("thanksYou");

            return;
        }

        TIWStore.CERTIFICATE_NUMBER = cutCertificateNumber(ContractSignInfo.certificateNumber);
        if (ContractSignInfo.additionalCertificates) {
            for (const { certificate } of ContractSignInfo.additionalCertificates) {
                // FIXME: исправь этот костыль.
                if (
                    !TIWStore.ADDITIONAL_CERTIFICATE_NUMBERS.includes(
                        cutCertificateNumber(certificate),
                    )
                ) {
                    // FIXME: не используй прямую мутацию стора. Лучше функцию в сторе.
                    TIWStore.ADDITIONAL_CERTIFICATE_NUMBERS.push(cutCertificateNumber(certificate));
                }
            }
        }

        await setDeviceStatus({
            token: TIWStore.WIDGET_DATA.token,
            deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId,
            status: "ONLINE_CONTRACT_SIGNED",
        });

        TIWStore.switchStep("creditCartPreAuthorization");
    } else {
        isSigned.value = false;
    }
}

async function sendSmsAgain() {
    loadingToNext.value = true;

    try {
        await it4SendContractToSign({
            token: TIWStore.WIDGET_DATA.token, // "d7bd115c-e845-4381-8f11-8044cbc11dfe",
            deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId, // deviceID сдаваемого устройства
            contractNumber: SuccessfulEvaluationStore.contractData.contractNumber,
        });
    } catch (e) {
        useBugTracker("Send Contract", BugTrackerSection.ERROR, {
            message: e?.message,
            request: {
                token: TIWStore.WIDGET_DATA.token,
                deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId,
                contractNumber: SuccessfulEvaluationStore.contractData.contractNumber,
            },
        });
    }

    isSigned.value = true;
    loadingToNext.value = false;
}
</script>

<template>
    <Modal data-component="confirmSigned" class="tiw__step__confirmSigned">
        <template #header>
            <p class="tiw__step__confirmSigned__header tiw__h2">
                <AwardIcon />
                {{ useTranslate("tiw__addToCart__title") }}
            </p>
            <p
                v-html="
                    useTranslate('tiw__addToCart__subtitle').replace(
                        '[[NUMBER]]',
                        SuccessfulEvaluationStore.individualFields.phone ??
                            SuccessfulEvaluationStore.companyFields.phone,
                    )
                "
            />
        </template>
        <p
            class="tiw__step__confirmSigned__info tiw__step__confirmSigned__info_desk tiw__text tiw_fs-12 tiw_usn"
        >
            <span>
                {{ useTranslate("tiw__addToCart__notContract") }}
            </span>
            <br />
            <Button
                color="link"
                variant="link"
                type="button"
                class="tiw_fs-12"
                :disabled="loadingToNext"
                @click="sendSmsAgain"
            >
                <span>
                    {{ useTranslate("tiw__addToCart__sendAgain") }}
                </span>
            </Button>
        </p>
        <div class="tiw__step__confirmSigned__body">
            <!-- Чекбокс "Я подписал договор" -->
            <!-- <Checkbox v-model="SuccessfulEvaluationStore.fields.acceptContract">
                <span> Я подписал договор </span>
            </Checkbox> -->
            <template v-if="!isSigned">
                <div class="tiw__step__confirmSigned__warn">
                    {{ useTranslate("tiw__addToCart__warn") }}
                </div>
            </template>
            <StepsButtons
                :no-back-btn="true"
                :loading="loadingToNext"
                :disabled="loadingToNext"
                :click-to-next="onNext"
            />
        </div>
    </Modal>
</template>

<style lang="scss" src="./confirmSigned.scss"></style>
